
/* ATTENTION!
This file is automatically generated by scripts/set-env.ts
Please do not change or commit it
*/
import { IEnvironment } from '@skychute/ui-models';
function isEqual(a: any, b: any): boolean {
    return a === b;
}
export const config: IEnvironment = {
    production: isEqual('true', 'true'),
    services: {
        data: {
          endpoint: 'https://feature-pre-1413-hasura.projectre.com.au',
          path: '/v1/graphql',
          logQueries: 'false'
        },
        aws: {
          UserPoolId: 'ap-southeast-2_8fv4YdVyk',
          AppClientId: '211lu7n13sragk6bmp8b701k6s',
          cloudUri: 'https://rcs2308k6k.execute-api.ap-southeast-2.amazonaws.com/dev',
        },
        analytics: {
            segment: {
                enabled: isEqual('false', 'true'),
                writeKey: 'CKazVWLN9swSOQAxq5aOOuUzu9MFuARF',
            },
        },
    },
    application: {
        version: '1.155.4',
        gitHead: '3843911e8866a1979c8b29eef035ce4778e4db94',
        branch: 'feature/PRE-1413',
        buildDate: 'March 12th 2026, 12:52:02 pm',
        buildNumber: '22',
    },
    stripe: {
        publicKey: 'pk_test_51JVQJzICXqe0hIJdVHDRyFoCVJbQwhWPayB7eHg1boYOy7FsCv7Sj1CJSYA2u6vPj4zRNbmsR6tsVu48e0yQEhYT00ycLtgphf'
    },
    addressFinder: {
        key: 'RBHCYUV987D4XKNPT6FL',
        src: 'https://api.addressfinder.io/assets/v3/widget.js'
    },
    courier_push_client_key:'ODM2OTc0NWItODA5NS00OTI3LWE1ZTEtMWI0OGEyZjBkNjg0L3Rlc3Q=',
    recaptcha_v3_site_key:'6LcmCVosAAAAAKHMw_lrGdsTChgK-IQ1L-cIlxV9',
    novu_push_client_key:'GVO-2E8_6qNx',
};
